export const BOW_TIE_SIDE = {
  PREVENTIVO: 'preventive',
  CORRETIVO: 'corrective',
};
